import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const territorialChallengesSlice = createSlice({
  name: "territorialChallenges",
  initialState,
  reducers: {
    // =========================
    // FETCH CHALLENGES
    // =========================
    fetchTerritorialChallengesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchTerritorialChallengesSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload;
    },
    fetchTerritorialChallengesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // =========================
    // BULK SAVE (Create/Update Multiple)
    // =========================
    saveTerritorialChallengesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    saveTerritorialChallengesSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload;
    },
    saveTerritorialChallengesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // =========================
    // CREATE SINGLE
    // =========================
    createSingleTerritorialChallengeRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createSingleTerritorialChallengeSuccess: (state, action) => {
      state.loading = false;
      state.items.push(action.payload);
    },
    createSingleTerritorialChallengeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // =========================
    // UPDATE SINGLE
    // =========================
    updateTerritorialChallengeRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateTerritorialChallengeSuccess: (state, action) => {
      state.loading = false;
      const index = state.items.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    updateTerritorialChallengeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // =========================
    // DELETE SINGLE
    // =========================
    deleteTerritorialChallengeRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteTerritorialChallengeSuccess: (state, action) => {
      state.loading = false;
      state.items = state.items.filter((c) => c.id !== action.payload);
    },
    deleteTerritorialChallengeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchTerritorialChallengesRequest,
  fetchTerritorialChallengesSuccess,
  fetchTerritorialChallengesFailure,
  saveTerritorialChallengesRequest,
  saveTerritorialChallengesSuccess,
  saveTerritorialChallengesFailure,
  createSingleTerritorialChallengeRequest,
  createSingleTerritorialChallengeSuccess,
  createSingleTerritorialChallengeFailure,
  updateTerritorialChallengeRequest,
  updateTerritorialChallengeSuccess,
  updateTerritorialChallengeFailure,
  deleteTerritorialChallengeRequest,
  deleteTerritorialChallengeSuccess,
  deleteTerritorialChallengeFailure,
} = territorialChallengesSlice.actions;

export default territorialChallengesSlice.reducer;